import React from 'react'
import { PropTypes } from 'prop-types'
import { flowRight } from 'lodash'
import { graphql } from '@apollo/client/react/hoc'

import deleteBos from 'graphql/bos/deleteBos.gql'

class BosDeleteLogic extends React.Component {
    mounted = false
    asyncSetState (...args) {
        // avoid setting state after unmount in case async operations attempts to do so
        if (this.mounted) this.setState(...args)
    }

    constructor () {
        super()

        this.state = {
            loading: false,
            error: false,
        }
    }

    componentDidMount () {
        this.mounted = true
    }

    componentWillUnmount () {
        this.mounted = false
    }

    deleteBos = async (bosId, cancelReason = '') => {
        this.asyncSetState({
            loading: true,
            error: false,
        })

        await this.props.deleteBos({
            variables: {
                id: bosId,
                cancelReason: cancelReason,
            },
        }).then(result => {
            if (result.data && result.data.deleteBos) {
                this.asyncSetState({
                    loading: false,
                    error: false,
                })

                return Promise.resolve(result)
            }

            this.asyncSetState({
                loading: false,
                error: result,
            })

            return Promise.reject(result)
        }).catch(error => {
            this.asyncSetState({
                loading: false,
                error: error,
            })

            return Promise.reject(error)
        })
    }

    actions = {
        deleteBos: this.deleteBos,
    }

    render () {
        return this.props.children({
            ...this.state,
            ...this.actions,
        })
    }
}

BosDeleteLogic.propTypes = {
    children: PropTypes.func.isRequired,
}

export default flowRight(
    graphql(deleteBos, { name: 'deleteBos' })
)(BosDeleteLogic)
